import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils/cn';
import { Container } from './Container';

export function Section({
  className,
  tinted,
  children,
  ...props
}: HTMLAttributes<HTMLElement> & { tinted?: boolean }) {
  return (
    <section className={cn('py-16 md:py-20', tinted && 'bg-surface-2/50', className)} {...props}>
      <Container>{children}</Container>
    </section>
  );
}

export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  action,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  action?: ReactNode;
}) {
  return (
    <div
      className={cn(
        'mb-10 flex flex-col gap-3',
        align === 'center' && 'items-center text-center',
        action && 'md:flex-row md:items-end md:justify-between',
      )}
    >
      <div className={cn(align === 'center' && 'max-w-2xl')}>
        {eyebrow && (
          <p className="mb-2 text-sm font-bold uppercase tracking-wide text-pink-600">{eyebrow}</p>
        )}
        <h2 className="text-3xl font-bold text-ink md:text-4xl">{title}</h2>
        {description && <p className="mt-3 text-muted">{description}</p>}
      </div>
      {action}
    </div>
  );
}

export function PageHeader({ title, description }: { title: string; description?: string }) {
  return (
    <div className="border-b border-line bg-surface-2/40">
      <Container className="py-12 md:py-16">
        <h1 className="text-4xl font-bold text-ink md:text-5xl">{title}</h1>
        {description && <p className="mt-3 max-w-2xl text-lg text-muted">{description}</p>}
      </Container>
    </div>
  );
}
